

import React , {useEffect} from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { FaSpinner } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

import CustomNav‌bar from '../components/Nav‌bar';
import Dashboard from './dashboard';

import '../styles/fa.css'
import '../styles/en.css'
import '../styles/ar.css'

const MainLayout =({title,showMenu=true,children})=>{
    

     const { t, i18n } = useTranslation();
    
      const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
      };
    
     useEffect(() => {
        document.documentElement.dir = i18n.language === 'fa' || i18n.language === 'ar' ? 'rtl' : 'ltr';
      }, [i18n.language]);
      
    
      
    // const { isLoading, loadingRef } = useLoading();

    return (<Container fluid className={i18n.language}>

       {showMenu &&  <CustomNav‌bar />}
       


        <Row className="vh-10000-">
       
    
         {children}
  
         
        </Row>
      </Container>)
    
  

};


export default MainLayout;